import { toast } from 'react-toastify'
import get from 'lodash.get'
import request from 'superagent'
import store from 'store2'
import { formatPhoneNumberIntl, parsePhoneNumber } from 'react-phone-number-input'

import APIRequest from '../../helpers/apiHelpers'
import { decodeEntities } from '../../helpers/stringHelpers'
import authHelpers from '../../helpers/authHelpers'
import routeHelpers from '../../helpers/routeHelpers'
import User from '../../models/user.model'
import blxUsers from '../../actions/users'

import CUSTOM_FIELD_COLUMNS from '../constants/customFieldColumns'

const maxStrikeCount = parseInt(process.env.REACT_APP_SESSION_STRIKE_COUNT, 10) || 3
let strikeCount = maxStrikeCount

const woaUsers = {
  getOAuthToken (thirdPartyToken) {
    return async (dispatch, getState) => {
      const { apiBase, clientId } = getState().config.input.config

      dispatch({
        type: 'USER_OAUTH_TOKEN_GET'
      })

      const session = await dispatch(woaUsers.getUserSession(true))
      const biddingStatus = get(session, 'session.biddingStatus')

      if (biddingStatus !== 'active') {
        return dispatch({
          type: 'USER_SESSION_CHECK_FAILED',
          err: 'invalid_session'
        })
      }

      return APIRequest.post(apiBase, clientId, 'ssologin', {
        token: thirdPartyToken
      })
        .then((res) => {
          const accessToken = get(res, 'body.accessToken')
          if (accessToken) {
            return dispatch({
              type: 'USER_OAUTH_TOKEN_GET_SUCCESS',
              token: accessToken,
              userModel: res.body
            })
          } else {
            return dispatch({
              type: 'USER_OAUTH_TOKEN_GET_FAILED',
              err: 'No access token found'
            })
          }
        })
        .catch((err) => {
          let message = get(err, 'response.body.message') || get(err, 'response.text') || get(err, 'message')
          try {
            const error = JSON.parse(message)
            message = get(error, 'message')
          } catch (e) {
            // Do nothing
          }
          // ! Patch for duplicate user error message
          if (message && message.toLowerCase().includes('[duplicate username]')) {
            message = 'Your email address requires updating to login. Contact MM Digital for assistance. +61 7 5504 1248 or info@magicmillions.digital'
          }
          toast.error(decodeEntities(message), {
            autoClose: false,
            closeOnClick: true
          })
          console.log('>>>> Parsed error message:', message)
          dispatch({
            type: 'USER_OAUTH_TOKEN_GET_ERROR',
            err
          })
        })
    }
  },
  getFreshUserModel () {
    return async (dispatch, getState) => {
      const oAuthConfig = getState().config.input.options.oAuth
      const tokenName = oAuthConfig.tokenName
      const thirdPartyToken = authHelpers.getCookie(tokenName)

      dispatch({
        type: 'USER_MODEL_GET'
      })

      if (!thirdPartyToken) {
        return dispatch({
          type: 'USER_MODEL_GET_FAILED',
          err: 'No token found',
          isLoading: false
        })
      }

      const authToken = await dispatch(woaUsers.getOAuthToken(thirdPartyToken))
      const user = get(authToken, 'userModel')
      if (user) {
        dispatch({
          type: 'USER_MODEL_GET_SUCCESS',
          user: new User(user).toJSON()
        })
      } else {
        dispatch({
          type: 'USER_MODEL_GET_FAILED',
          err: 'User not found.',
          isLoading: false
        })
      }
    }
  },
  getUserSession (silent = false) {
    return (dispatch, getState) => {
      dispatch({
        type: 'USER_SESSION_CHECK'
      })

      const oAuthConfig = getState().config.input.options.oAuth
      const tokenName = oAuthConfig.tokenName
      const thirdPartyToken = authHelpers.getCookie(tokenName)

      if (!thirdPartyToken) {
        dispatch(woaUsers.terminateUserSession(silent))
        return dispatch({
          type: 'USER_SESSION_CHECK_FAILED',
          err: 'No token found'
        })
      }

      try {
        return request.get(`${oAuthConfig.ssoLoginUrl}/session`)
          .set('Content-Type', 'application/json')
          .set('Authorization', `Bearer ${thirdPartyToken}`)
          .then(response => {
            if (response.status !== 200) {
              strikeCount -= 1
              // console.log('>>>>> Strike count after bad response (1):', strikeCount, response)
              if (strikeCount <= 0) {
                dispatch(woaUsers.terminateUserSession(silent))
                strikeCount = maxStrikeCount
                return dispatch({
                  type: 'USER_SESSION_CHECK_FAILED',
                  err: 'invalid_response'
                })
              }
            }
            return response.body
          })
          .then(result => {
            if (get(result, 'status_code') !== 200) {
              strikeCount -= 1
              // console.log('>>>>> Strike count after bad response (2):', strikeCount)
              if (strikeCount <= 0 || get(result, 'error') === 'invalidated_session') {
                dispatch(woaUsers.terminateUserSession(silent))
                strikeCount = maxStrikeCount
              }
              return dispatch({
                type: 'USER_SESSION_CHECK_FAILED',
                err: get(result, 'error')
              })
            } else if (get(result, 'response.status') !== 'active') {
              dispatch(woaUsers.terminateUserSession(silent))
              return dispatch({
                type: 'USER_SESSION_CHECK_FAILED',
                err: 'Your account is not active.'
              })
            }

            const countryName = get(result, 'response.countryName')
            let countryIdList = store('bidJs__countryIds') || {}
            if (!Object.keys(countryIdList).length) {
              const countries = getState().users?.referenceData?.countries || []
              countryIdList = countries.reduce((acc, country) => {
                acc[country.name] = country.id
                return acc
              }, {})
              store('bidJs__countryIds', countryIdList)
            }
            const countryId = countryIdList[countryName] || 15 // Default to Australia if country not found
            strikeCount = maxStrikeCount
            return dispatch({
              type: 'USER_SESSION_CHECK_SUCCESS',
              session: {
                biddingStatus: get(result, 'response.status'),
                maxSpend: get(result, 'response.creditLimit'),
                mobilePhone: get(result, 'response.mobilePhone'),
                email: get(result, 'response.email'),
                addressDetails: {
                  addressLine1: get(result, 'response.streetAddress'),
                  addressLine2: get(result, 'response.streetAddress2'),
                  city: get(result, 'response.city'),
                  state: get(result, 'response.state'),
                  postalCode: get(result, 'response.zipCode'),
                  countryId: countryId
                }
              }
            })
          })
          .catch(err => {
            strikeCount -= 1
            // console.log('>>>>> Strike count after bad response (3):', strikeCount)
            if (strikeCount <= 0) {
              dispatch(woaUsers.terminateUserSession(silent))
              strikeCount = maxStrikeCount
              return dispatch({
                type: 'USER_SESSION_CHECK_FAILED',
                err: err
              })
            }
          })
      } catch (err) {
        strikeCount -= 1
        // console.log('>>>>> Strike count after bad response (4):', strikeCount)
        if (strikeCount <= 0) {
          dispatch(woaUsers.terminateUserSession(silent))
          strikeCount = maxStrikeCount
          return dispatch({
            type: 'USER_SESSION_CHECK_FAILED',
            err: 'invalid_response'
          })
        }
      }
    }
  },
  terminateUserSession (silent = false) {
    return (dispatch, getState) => {
      if (!silent) {
        toast.error('You\'ve been logged out because your session has expired or another device has logged in.', {
          autoClose: false
        })
      }

      authHelpers.handleUnauthentication(getState().config.input.options.oAuth.tokenName)

      routeHelpers.navigate('/logout')

      return dispatch({
        type: 'USER_SESSION_TERMINATED',
        err: 'invalid_session'
      })
    }
  },
  login (identifier, password) {
    return async (dispatch, getState) => {
      const oAuthConfig = getState().config.input.options.oAuth
      dispatch({
        type: 'USER_LOGIN'
      })
      try {
        const authenticate = await request.post(`${oAuthConfig.ssoLoginUrl}/authenticate`)
          .set('Content-Type', 'application/json')
          .send({
            username: identifier,
            password,
            authenticate: true
          })
          .then(response => {
            if (response.status !== 200) {
              toast.error('Invalid Login.')
              dispatch({
                type: 'USER_LOGIN_FAILED',
                err: 'Invalid Login.'
              })
            }
            return response.body
          })
          .then(result => {
            if (get(result, 'status_code') !== 200) {
              const error = get(result, 'error') || 'Invalid username or password.'
              toast.error(error)
              dispatch({
                type: 'USER_LOGIN_FAILED',
                err: error
              })
            } else {
              if (get(result, 'biddingStatus') !== 'active') {
                toast.error('Your account is not active.')
                dispatch({
                  type: 'USER_LOGIN_FAILED',
                  err: 'Your account is not active.'
                })
              }
            }
            return result
          })
          .catch(err => {
            toast.error('Invalid username or password. (2)')
            console.error(err)
            dispatch({
              type: 'USER_LOGIN_FAILED',
              err: 'Invalid username or password.'
            })
          })

        const { accessToken, sessionId } = authenticate
        const expiryDate = new Date()
        expiryDate.setDate(expiryDate.getDate() + 7)
        document.cookie = `${oAuthConfig.tokenName}=${accessToken}; expires=${expiryDate.toUTCString()}; path=/;`
        document.cookie = `sessionid=${sessionId}; expires=${expiryDate.toUTCString()}; path=/;`
        const authToken = await dispatch(woaUsers.getOAuthToken(accessToken))

        // if (get(authToken, 'err')) {
        //   toast.error('Invalid username or password. (3)')
        //   dispatch({
        //     type: 'USER_LOGIN_FAILED',
        //     err: 'Invalid username or password.'
        //   })
        // }

        const user = get(authToken, 'userModel')
        if (user) {
          authHelpers.handleAuthentication(user.accessToken)
          const getUser = new User(user).toJSON()
          strikeCount = maxStrikeCount
          // console.log('>>> Strike Refreshed to:', strikeCount)
          // Modify the user account details for first time login
          const inserted = get(user, 'inserted')
          let createdAt = ''
          if (inserted) {
            const date = new Date(inserted)
            const options = { year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'UTC' }
            createdAt = date.toLocaleString('en-US', options).replaceAll(',', '').replace('at', '').trim() + ' UTC'
          }
          const penultimateLogin = get(user, 'penultimateLogin').replaceAll(',', '').trim()
          if (penultimateLogin === createdAt) {
            const { userAccount } = await dispatch(blxUsers.getExistingAccount())
            let telephone = userAccount.telephone
            if (telephone && !telephone.startsWith('+')) {
              telephone = '+' + telephone
            }
            const formatPhoneNumber = formatPhoneNumberIntl(telephone)
            const { country } = parsePhoneNumber(telephone)
            userAccount.telephone = formatPhoneNumber || telephone
            userAccount.fax = JSON.stringify({ countryCode: country, sms: true, oet: Date.now() })
            userAccount.timezoneId = 318 // Australia/Brisbane as default
            await dispatch(blxUsers.patchAccount(getUser.uuid, userAccount))
          }

          dispatch({
            type: 'USER_MODEL_GET_SUCCESS',
            user: getUser
          })

          return dispatch({
            type: 'USER_LOGIN_SUCCESS',
            user: getUser
          })
        }
      } catch (err) {
        return dispatch(woaUsers.getUserSession())
          .then(
            dispatch({
              type: 'USER_LOGIN_FAILED',
              err: 'User not found.'
            })
          )
      }
    }
  },
  getColumnConfig: ({ userUuid }) => {
    return (dispatch, getState) => {
      dispatch({
        type: 'COLUMN_CONFIG_GET'
      })

      const columns = store('bidJs__columnConfig')

      // If columns are available in local storage, use them
      if (Array.isArray(columns) && columns.length) {
        return dispatch({
          type: 'COLUMN_CONFIG_GET_SUCCESS',
          columns
        })
      }

      if (!userUuid) {
        return dispatch({
          type: 'COLUMN_CONFIG_GET_FAILED',
          err: 'No userUuid provided and no column config in local storage'
        })
      }

      const oAuthConfig = getState().config.input.options.oAuth
      const tokenName = oAuthConfig.tokenName
      const thirdPartyToken = authHelpers.getCookie(tokenName)

      if (!thirdPartyToken) {
        return dispatch({
          type: 'COLUMN_CONFIG_GET_FAILED',
          err: 'No token found'
        })
      }

      try {
        return request.get(`${oAuthConfig.ssoLoginUrl}/column-config?userUuid=${userUuid}`)
          .set('Content-Type', 'application/json')
          .set('Authorization', `Bearer ${thirdPartyToken}`)
          .then(response => {
            if (get(response, 'body.status_code') === 200) {
              let serverColumns = get(response, 'body.response')
              // Save the server response to local storage for future use
              if (!Array.isArray(serverColumns) || !serverColumns.length) {
                serverColumns = CUSTOM_FIELD_COLUMNS.map((column) => (column?.configShowDefault || !column?.configExclude) && column.key)
              }
              store('bidJs__columnConfig', serverColumns)
              return dispatch({
                type: 'COLUMN_CONFIG_GET_SUCCESS',
                columns: serverColumns
              })
            }
            return dispatch({
              type: 'COLUMN_CONFIG_GET_FAILED',
              err: 'Invalid server response'
            })
          })
          .catch(err => {
            console.error('Error fetching column config from server:', err)
            return dispatch({
              type: 'COLUMN_CONFIG_GET_FAILED',
              err: 'Request failed'
            })
          })
      } catch (err) {
        console.error('Unexpected error:', err)
        return dispatch({
          type: 'COLUMN_CONFIG_GET_FAILED',
          err: 'Unexpected error'
        })
      }
    }
  },
  setColumnConfig: ({ userUuid, columns }) => {
    return (dispatch, getState) => {
      dispatch({
        type: 'COLUMN_CONFIG_SET'
      })

      if (!Array.isArray(columns)) {
        return dispatch({
          type: 'COLUMN_CONFIG_SET_FAILED',
          err: 'Columns should be an array'
        })
      }

      const validKeys = CUSTOM_FIELD_COLUMNS.map(column => (column?.configShowDefault || !column?.configExclude) && column.key)
      const verfiedColumns = columns.filter(column => validKeys.includes(column))

      store('bidJs__columnConfig', verfiedColumns)

      if (!userUuid) {
        return dispatch({
          type: 'COLUMN_CONFIG_SET_SUCCESS',
          columns: verfiedColumns
        })
      }

      const oAuthConfig = getState().config.input.options.oAuth
      const tokenName = oAuthConfig.tokenName
      const thirdPartyToken = authHelpers.getCookie(tokenName)

      if (!thirdPartyToken) {
        return dispatch({
          type: 'COLUMN_CONFIG_SET_FAILED',
          err: 'No token found'
        })
      }

      try {
        return request.post(`${oAuthConfig.ssoLoginUrl}/column-config`)
          .set('Content-Type', 'application/json')
          .set('Authorization', `Bearer ${thirdPartyToken}`)
          .send({
            userUuid,
            columns: verfiedColumns
          })
          .then(response => {
            if (get(response, 'body.status_code') === 200) {
              return dispatch({
                type: 'COLUMN_CONFIG_SET_SUCCESS',
                columns: get(response, 'body.response')
              })
            }
            return dispatch({
              type: 'COLUMN_CONFIG_SET_FAILED',
              err: 'invalid_response'
            })
          })
          .catch(err => {
            return dispatch({
              type: 'COLUMN_CONFIG_SET_FAILED',
              err: err
            })
          })
      } catch (err) {
        console.error('>>>> error', err)
        return dispatch({
          type: 'COLUMN_CONFIG_SET_FAILED',
          err
        })
      }
    }
  }
}

const users = {
  ...blxUsers,
  ...woaUsers
}

export default users
